export const L10ManageMembers = /** @type {const} */ ({
  filterbyRoleType: 'Filter by Role',
  filterByLicenseType: 'Filter by License',
  filterByAddon: 'Filter by Addon',
  filterByTeamType: 'Filter by Team',
  filterByPrimaryTeam: 'Filter by primary team',
  noTeam: 'No Team',
  noTeamDescription: 'Members not a part of any team',
  filterByDialers: 'Filter by Dialer',
  membersNotPartOfAnyTeam: 'Members not a part of any team',
  calendar: 'Calendar',
  calendarConnection: 'Calendar connection',
  internalMeetings: 'Internal Meetings',
  externalMeetings: 'External Meetings',
  googleMeet: 'Google Meet',
  googleMeetCloudRecording: 'Google Meet',
  microsoftCloudRecording: 'Microsoft Teams',
  recordingPreferences: 'Recording preferences',
  autoRecording: 'Auto-Recording',
  zoom: 'Zoom',
  voiceprint: 'Voiceprint',
  internalMeetingsLowerCase: 'Internal meetings',
  externalMeetingsLowerCase: 'External meetings',
  userStatus: 'User status',
  invited: 'Invited',
  primaryTeam: 'Primary team',
  deactivatedBy: 'Deactivated by',
  filterByCalendarIntegration: 'Filter by Calendar Integration',
  filterByCalendarConnectionStatus: 'Filter by calendar connection status',
  filterByUserStatus: 'Filter by user status',
  filterByRecordingPreferences: 'Filter by recording preferences',
  filterByAutoRecordingSettings: 'Filter by auto-recording settings',
  filterByInternalMeetingsRecording: 'Filter by Internal Meetings Recording',
  filterByExternalMeetingsRecording: 'Filter by External Meetings Recording',
  filterByGoogleMeetIntegration: 'Filter by Google Meet Integration',
  filterByMicrosoftTeamsIntegration: 'Filter by Microsoft Teams Integration',
  filterByGoogleMeetCloudRecording: 'Filter by cloud recording',
  filterByMicrosoftCloudRecording: 'Filter by Microsoft Teams cloud recording',
  filterByZoomSettings: 'Filter by zoom settings',
  cloudRecording: 'Cloud recording',
  autoRecordingLowerCase: 'Auto recording',
  hostOnly: 'Host Only',
  participantOnly: 'Participant Only',
  hostOrParticipant: 'Host or Participant',
  pmiRecording: 'PMI recording',
  autoDelete: 'Auto delete',
  notUsingPMI: 'Not using PMI',
  zoomApps: 'Zoom apps',
  filterByVoiceprint: 'Filter by voiceprint',
  meetingPrivacy: 'Meeting Privacy',
  filterByMeetingPrivacy: 'Filter by Meeting Privacy',
  filterByMeetingPrivacySettings: 'Filter by meeting privacy',
  internalMeetingPrivacy: 'Internal meetings',
  externalMeetingPrivacy: 'External meetings',
  visibleToOrganization: 'Visible to Organization',
  privateToMember: 'Private to Participants',
  primaryTeamAccess: 'Visible to Specific Teams',
  searchForAMember: 'Search for a member'
});
